export default __webpack_public_path__ + "static/more-assets-graphic-a69bc6791010fc10ad3ec24caecaddad.svg";